// removed by extract-text-webpack-plugin
module.exports = {"block":"VzpMcGrlm6rUe5slwLc52","header":"gYOjaxCz7AMfT3dgXyopg","block-heading":"_1RW5HeWbqHKoaDg8KzVYSp","block-intro":"_199clW1ShuPSUCvrvdY2Tf","condensed":"_1XTXDDg26wXwo6cvKhBWbn","videos":"_5iwglW04UBo9Ej2M0njOq","playing":"_2uREbycgpVybYWChqHKwak","video":"_10Io-qd5QEQQ9zhu5U5qcO","preview":"_2thXpSmCvSVSrjvNcQ66wH","squared":"_2DGJH2RS7dKDajMhxbshVk","active":"_3a67OJJYsiZ6nlIDz2xiR9","subtitle":"_3J3zxsV6gnMzm5-hiZARdb","description":"_35ukG4jMm8ggwaP03jbo-x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoListBlock/VideoListBlock.module.scss
// module id = 816
// module chunks = 0